/* eslint-disable no-console */
export default {
  name: 'app',
  components: {
    // Content,
  },

  data() {
    return {
    }
  },

  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },

  watch: {
    '$route'(to, from) {
      document.body.className = 'home';
    }
  },

  mounted() {
    const path = localStorage.getItem('path');
    if (path) {
      localStorage.removeItem('path');
      this.$router.push({ path });
    }
  },
}